import { AC_STEP_CONFIRM_AGE } from "../../utils/AccountCreationConstants";

import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

const useAccountCreationParentWarning = () => {
  const { updateAccountCreationStep } = useAccountCreationData();

  const onContinueClicked = () => {
    updateAccountCreationStep(AC_STEP_CONFIRM_AGE);
  };

  return {
    onContinueClicked
  };
};

export default useAccountCreationParentWarning;